/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
import{addProjViewLocalOrigin as e}from"../views/3d/webgl-engine/core/shaderLibrary/util/View.glsl.js";import{FloatPassUniform as i}from"../views/3d/webgl-engine/core/shaderModules/FloatPassUniform.js";import{glsl as o}from"../views/3d/webgl-engine/core/shaderModules/interfaces.js";import{ShaderBuilder as r}from"../views/3d/webgl-engine/core/shaderModules/ShaderBuilder.js";import{VertexAttribute as a}from"../views/3d/webgl-engine/lib/VertexAttribute.js";function t(t){const s=new r,{vertex:d,fragment:u,attributes:n,varyings:l}=s;e(d,t);const{isAttributeDriven:c,usesHalfFloat:f}=t;return n.add(a.POSITION,"vec3"),n.add(a.UV0,"vec2"),c&&(n.add(a.FEATUREATTRIBUTE,"float"),l.add("attributeValue","float")),f&&s.constants.add("compressionFactor","float",.25),l.add("unitCirclePos","vec2"),d.uniforms.add(new i("radius",(({resolutionForScale:e,searchRadius:i},{camera:o,screenToWorldRatio:r,overlayStretch:a})=>2*i*(0===e?1:e/r)*o.pixelRatio/o.fullViewport[2]/a))),d.code.add(o`
    void main() {
      unitCirclePos = uv0;

      vec4 posProj = proj * (view * vec4(${a.POSITION}, 1.0));
      vec4 quadOffset = vec4(unitCirclePos * radius, 0.0, 0.0);

      ${c?o`attributeValue = ${a.FEATUREATTRIBUTE};`:""}
      gl_Position = posProj + quadOffset;
    }
  `),u.code.add(o`
    void main() {
      float radiusRatioSquared = dot(unitCirclePos, unitCirclePos);
      if (radiusRatioSquared > 1.0) {
        discard;
      }

      float oneMinusRadiusRatioSquared = 1.0 - radiusRatioSquared;
      float density = oneMinusRadiusRatioSquared * oneMinusRadiusRatioSquared ${c?o` * attributeValue`:""} ${f?o` * compressionFactor`:""};
      fragColor = vec4(density);
    }
  `),s}const s=Object.freeze(Object.defineProperty({__proto__:null,build:t},Symbol.toStringTag,{value:"Module"}));export{s as H,t as b};
